// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"b87d101be33b23ff0a03","454":"e26b618187478acc3eaf"}[chunkId] + ".js";
};